export default __webpack_public_path__ + "static/media/logo_200.5bab7098.png";